import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { AnnualDeclarationFormService } from '../shared/service/annual-declaration-form.service';

export interface FormData {
  societeId: string;
  formYear: number;
}

@Component({
    selector: 'odq-voting-parts-summary-dialog',
    templateUrl: './voting-parts-summary-dialog.component.html',
    styleUrls: ['./voting-parts-summary-dialog.component.scss'],
    standalone: false
})
export class VotingPartsSummaryDialogComponent implements OnDestroy, OnInit {

  destroy$ = new Subject<void>();
  hasTrusteesErrors = !this.annualDeclarationFormService.iskTrusteesCountValid();
  hasVotingPartsCountErrors = !this.annualDeclarationFormService.isVotingPartsTotalsValid();

  myGroup: UntypedFormGroup;

  constructor(
    private annualDeclarationFormService: AnnualDeclarationFormService,
    public dialogRef: MatDialogRef<VotingPartsSummaryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public formData: FormData,
  ) { }

  ngOnInit() {
    const memberTotal = this.annualDeclarationFormService.getMembersVotingPartsTotal();
    const legalPersonTotal = this.annualDeclarationFormService.getLegalPersonsVotingPartsTotal();
    const allVotingTotal = this.annualDeclarationFormService.getAllVotingPartsTotal();

    this.myGroup = new UntypedFormGroup({
      numberVotingODQ: new UntypedFormControl(memberTotal),
      numberVotingOther: new UntypedFormControl(legalPersonTotal),
      numberVotingTotal: new UntypedFormControl(allVotingTotal),
    });

    this.myGroup.disable();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  fixErrors() {
    if (this.hasTrusteesErrors) {
      this.dialogRef.close('nbTrustees');
    } else {
      this.dialogRef.close();
    }
  }

  nextStep() {
    this.dialogRef.close('nextStep');
  }

}
